import React, { Component } from 'react';
import { Row, Select, Popover, Radio } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  keys,
  keyBy,
  toString,
  get,
  find,
  forEach,
  forEachRight,
  replace,
  filter,
  has,
  cloneDeep,
  indexOf,
  drop,
  isString,
  split,
  lowerCase,
  isNull,
  isObject,
  map
} from 'lodash';
import validator from 'validator';
import { getCountryCallingCode } from 'libphonenumber-js';
import ReactCountryFlag from 'react-country-flag';
import stringSimilarity from 'string-similarity';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import helpers from 'utils/helpers';

import pickupAreas from 'data/pickupAreas';

import {
  FormTitle,
  StyledInput,
  StyledSelect,
  StyledFormItem,
  StyledCol,
  StyledRadioGroupHorizontal
} from 'components/Styled';
import StateSelect from './StateSelect';
import AreaSelect from './AreaSelect';
import states from 'data/states';

const { rp } = helpers;

const abbreviations = {
  Avenue: 'Ave',
  Boulevard: 'Blvd',
  Building: 'Bldg',
  Court: 'Crt',
  Crescent: 'Cres',
  Drive: 'Dr',
  Place: 'Pl',
  Road: 'Rd',
  Square: 'Sq',
  Station: 'Stn',
  Street: 'St',
  Terrace: 'Terr',
  Floor: '/F',
  Room: 'Rm',
  Block: 'Blk'
};

const shortForm = str => {
  let arr = str.split(' ');
  arr = arr.map(el => {
    el = has(abbreviations, el) ? el.replace(el, abbreviations[el]) : el;
    return el;
  });
  const temp = arr.reduce((a, b) => a + `${b} `, '');
  return temp.slice(0, temp.length - 1);
};

const { Option } = Select;

const formSubtitle = {
  fontWeight: 400,
  color: '#ced4da'
};

class AddressCard extends Component {
  state = {
    street1: '',
    street2: '',
    street3: '',
    city: '',
    cities: null,
    suggestedCity: '',
    state: '',
    zip: '',
    name: '',
    company: '',
    phoneCc: getCountryCallingCode(this.props.country),
    phone: '',
    region: '', // for Hong Kong
    area: '', // for Hong Kong
    country: this.props.country, // country code shortcode cache
    unit: '',
    drawerName: 'street1',
    drawerVisible: false,
    maxLength: 105,
    isSuggested: false,
    type: 'RESIDENTIAL',
    tntSuggesting: false
  };

  gtmSubject = this.props.fromAddress ? 'Pickup' : 'Receiver';

  gtmEvents = {
    name: `Inputted ${this.gtmSubject} Name`,
    company: `Inputted ${this.gtmSubject} Company`,
    phone: `Inputted ${this.gtmSubject} Tel`,
    street1: `Inputted ${this.gtmSubject} Address 1`,
    street2: `Inputted ${this.gtmSubject} Address 2`,
    street3: `Inputted ${this.gtmSubject} Address 3`
  };

  phoneCountry = keys(keyBy(this.props.countries, 'alpha-2'))
    .map(x => {
      const value = getCountryCallingCode(x);
      const flag = (
        <ReactCountryFlag
          countryCode={x}
          style={{ width: 20, height: 20, padding: '0 8px 4px 0' }}
          svg
        />
      );
      const label = `+${value}`;
      return { key: x, label, value, flag };
    })
    .sort((a, b) => a.value - b.value);

  handleTextInputChange = (value, name) => {
    let val = value || '';
    // if (name === 'zip') val = val.replace('-', '');
    this.setState({
      [name]: val
    });
  };

  handleTextInputBlur = name => {
    if (this.gtmEvents[name]) {
      window.dataLayer.push({
        event: this.gtmEvents[name],
        ecommerce: undefined,
        pickupInput: toString(this.state[name])
      }); // move to blur event to prevent fire while inputting
    }

    this.handleGtmFire(name);
    this.setState({
      [name + 'Changed']: true
    });

    this.getHelpStatus(name);
    this.autoSave();
    if (name === 'zip') {
      this.getSuggestion({
        country: this.props.country,
        zip: this.state.zip
      });
      this.setState({ tntSuggesting: true, city: '' });
    }
  };

  handleInputChange = (value, name) => {
    if (this.gtmEvents[name]) {
      const eventValue =
        name === 'pickupDate' ? moment(value).format('YY-MM-DD') : value;
      window.dataLayer.push({
        event: this.gtmEvents[name],
        ecommerce: undefined,
        pickupInput: eventValue
      });
    }

    this.setState(
      {
        [name]: value
      },
      () => {
        this.getHelpStatus(name);
      }
    );
  };

  handleInputBlur = name => {
    this.setState({
      [name + 'Changed']: true
    });

    this.getHelpStatus(name);
    this.autoSave();
    this.handleGtmFire(name);
  };

  replaceCity = message => {
    if (isNull(message)) return null;

    message = toString(message);
    if (this.props.country === 'TW') {
      message = message.replace(new RegExp('city', 'g'), 'city_TW');
    }

    if (this.props.country === 'JP') {
      message = message.replace(new RegExp('city', 'g'), 'city_JP');
    }

    return message;
  };

  getHelpStatus = name => {
    const rs = this.validateError(name);
    const newState = {
      help: null,
      status: ''
    };

    if (isString(rs)) {
      newState.help = rs;
      if (name === 'city') newState.help = this.replaceCity(rs);
      newState.status = 'error';
    }

    if (isObject(rs)) {
      newState.help = rs.help;
      if (name === 'city') newState.help = this.replaceCity(rs.help);
      newState.status = rs.status || 'error';
    }

    this.setState({
      [name + 'Status']: newState.status,
      [name + 'Help']: newState.help
    });
  };

  validateType = {
    street1: 'street1',
    street2: 'street2',
    street3: 'street3',
    city: this.props.country === 'HK' ? null : 'required',
    state: states[this.props.country] ? 'required' : null,
    zip: get(
      find(this.props.countries, ['alpha-2', this.props.country]),
      'require-postal-code'
    )
      ? 'zip'
      : null,
    name: 'name',
    company: 'optional',
    phone: 'phone',
    area: this.props.country === 'HK' ? 'area' : null, // for Hong Kong
    unit: this.props.country === 'HK' ? 'required' : 'optional'
  };

  validate = () => {
    const fields = [
      'street1',
      'street2',
      'street3',
      'city',
      'state',
      'zip',
      'name',
      'company',
      'phone',
      'area',
      'unit'
    ];

    const newState = {};
    forEach(fields, field => {
      states[field + 'Changed'] = true;
      this.getHelpStatus(field);
    });

    this.setState(newState);

    for (var i = 0; i < fields.length; i++) {
      if (isObject(this.validateError(fields[i]))) {
        if (this.validateError(fields[i]).status === 'error') return false;
      } else {
        if (this.validateError(fields[i])) return false;
      }
    }

    return true;
  };

  validateError = name => {
    let patterns;
    const value = toString(this.state[name]);

    if (
      value.length > 35 &&
      indexOf(['street1', 'street2', 'street3'], this.validateType[name]) ===
        -1 &&
      name !== 'name'
    ) {
      return {
        help: 'common.err_msg.length',
        status: 'error'
      };
    }

    switch (this.validateType[name]) {
      case 'optional':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return null;
        }

        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'required':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (name === 'city') {
          let type =
            this.state.cities || this.state.tntSuggesting ? 'select' : 'input';
          if (validator.isEmpty(value, { ignore_whitespace: true })) {
            return `pickup.err_msg.city.empty.${type}`;
          }
        }

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'area':
        patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        if (value === 'Lantau Island' && this.props.fromAddress) {
          return {
            help: 'pickup.err_msg.streets.warning.lantau_island',
            status: 'warning'
          };
        }
        if (value === 'Tung Chung' && this.props.fromAddress) {
          return {
            help: 'pickup.err_msg.streets.warning.tung_chung',
            status: 'warning'
          };
        }
        return null;
      case 'phone':
        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!validator.isMobilePhone(replace(value, /\s/g, ''))) {
          return `pickup.err_msg.${name}.format`;
        }

        return null;
      case 'chars':
        patterns = /^[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'name':
        patterns = /^[A-Z\s\-.']+\s[A-Z\s\-.']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'zip': // TODO: match country
        patterns = /^[0-9A-Z\s\-']+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return `pickup.err_msg.${name}.empty`;
        }
        if (!patterns.test(value)) {
          return `pickup.err_msg.${name}.format`;
        }
        return null;
      case 'street1':
      case 'street2': {
        const rs = this.validateStreets();
        if (isString(rs)) {
          return '';
        } else if (isObject(rs)) {
          return {
            help: '',
            status: rs.status
          };
        }
        return null;
      }
      case 'street3':
        return this.validateStreets();
      default:
        return null;
    }
  };

  handleUnitBlur = () => {
    this.getHelpStatus('unit');
    this.setState({ unitChanged: true }, this.checkStreetsLength);
    this.autoSave();
  };

  handleStreetsBlur = () => {
    const fields = ['street1', 'street2', 'street3'];
    const newState = {};

    forEach(fields, field => {
      this.getHelpStatus(field);
      newState[field + 'Changed'] = true;
      this.handleGtmFire(field);
    });

    this.setState(newState, this.checkStreetsLength);
    this.autoSave();
  };

  handleTypeOnChange = e => {
    this.setState({
      type: e.target.value
    });
  };

  checkStreetsLength = () => {
    let { maxLength } = this.state;

    switch (this.props.carrier) {
      case 'fedex':
        maxLength = 70;
        break;
      case 'tnt':
        maxLength = 90;
        break;
    }

    this.setState({
      maxLength
    });

    const unit = toString(this.state.unit);
    const street1 = toString(this.state.street1);
    const street2 = toString(this.state.street2);
    const street3 = toString(this.state.street3);

    const streets = `${unit}${street1}${street2}${street3}`;
    const inputLength = streets.length;

    const fields = ['unit', 'street1', 'street2', 'street3'];

    if (inputLength > maxLength) {
      forEach(fields, field => {
        this.setState({
          [field + 'Status']: 'error'
        });
      });
    } else {
      forEach(fields, name => {
        const rs = this.validateError(name);
        const newState = {
          help: null,
          status: ''
        };

        const changed = this.state[name + 'Changed'];
        if (changed && isString(rs)) {
          newState.help = rs;
          newState.status = 'error';
        }

        if (changed && isObject(rs)) {
          newState.help = rs.help;
          newState.status = rs.status || 'error';
        }

        this.setState({
          [name + 'Status']: newState.status,
          [name + 'Help']: newState.help
        });
      });
    }
  };

  validateStreets = () => {
    const patterns = /^[0-9A-Z\s\-.,/'"():;$&@!?#]+$/i;
    const streetNumberPattern = /.*[0-9].*/;

    const street1 = toString(this.state.street1);
    const street2 = toString(this.state.street2);
    const street3 = toString(this.state.street3);

    const streets = `${street1}${street2}${street3}`;

    if (
      validator.isEmpty(streets, { ignore_whitespace: true }) ||
      validator.isEmpty(street1, { ignore_whitespace: true })
    ) {
      return 'pickup.err_msg.streets.empty';
    }

    const elements = split(`${street1},${street2},${street3}`, ',');
    const hkAddressError = this.validateHkPickupAddress(elements);
    if (hkAddressError && this.props.fromAddress) {
      return {
        help: hkAddressError,
        status: 'warning'
      };
    }

    if (!patterns.test(streets)) {
      return 'pickup.err_msg.streets.format';
    }

    if (this.props.country === 'HK' && !streetNumberPattern.test(streets)) {
      return 'pickup.err_msg.streets.missing_street_number';
    }

    return null;
  };

  validateHkPickupAddress = elements => {
    let type;

    // get similarity > score and most similar
    forEach(elements, el => {
      forEach(pickupAreas, area => {
        if (type) return;

        const similarity = stringSimilarity.compareTwoStrings(
          `${lowerCase(el)}`,
          `${lowerCase(area.key)}`
        );
        let score = 0.8;

        if (similarity >= score) {
          type = area.value;
        }
      });
    });

    return type;
  };

  getFormData = () => {
    const {
      street1,
      street2,
      street3,
      city,
      state,
      zip,
      name,
      company,
      phoneCc,
      phone,
      region,
      area,
      unit,
      type
    } = this.state;

    return {
      street1,
      street2,
      street3,
      city,
      state,
      zip,
      name,
      company,
      phoneCc,
      phone,
      region,
      area,
      unit,
      type
    };
  };

  autoSave = () => {
    this.props.autoSave();
  };

  calculateExceed = () => {
    let { unit, street1, street2, street3, maxLength } = this.state;
    unit = toString(unit);
    street1 = toString(street1);
    street2 = toString(street2);
    street3 = toString(street3);

    const exceed =
      unit.length +
      street1.length +
      street2.length +
      street3.length -
      maxLength;

    return exceed;
  };

  componentDidMount() {
    const { recoverAddress } = this.props;

    this.setState({
      ...recoverAddress
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.cities !== this.state.cities)
      this.setState({ tntSuggesting: false });
  }

  checkCodeAndCountry = (country, code) => {
    const realCode = getCountryCallingCode(country);
    if (code === realCode) {
      return `${country}_${code}`;
    } else {
      let arr = filter(this.phoneCountry, { value: code });
      if (arr.length > 0) return `${arr[0].key}_${code}`;
    }
  };

  checkMatches = arr => {
    const country = this.props.country;

    const temp = filter(arr, el => el !== 'political');
    let type = temp.length > 0 ? temp[0] : '';
    switch (type) {
      case 'floor': {
        return 'floor';
      }
      case 'subpremise': {
        return 'floor';
      }
      case 'premise': {
        return 'streets';
      }
      case 'street_number': {
        return 'streetNumber';
      }
      case 'route': {
        return 'streets';
      }
      case 'sublocality_level_4': {
        return 'streets';
      }
      case 'sublocality_level_3': {
        return 'streets';
      }
      case 'sublocality_level_2': {
        return 'streets';
      }
      case 'sublocality_level_1': {
        return 'streets';
      }
      case 'sublocality': {
        return 'streets';
      }
      case 'locality': {
        switch (country) {
          case 'US':
            return 'city';
          default:
            return 'streets';
        }
      }
      case 'administrative_area_level_4': {
        return 'streets';
      }
      case 'administrative_area_level_3': {
        return 'streets';
      }
      case 'administrative_area_level_2': {
        switch (country) {
          case 'US':
          case 'GB':
            return false;
          default:
            return 'streets';
        }
      }
      case 'administrative_area_level_1': {
        switch (country) {
          case 'CA':
          case 'US':
            return 'state';
          case 'GB':
          case 'HK':
            return false;
          default:
            return 'city';
        }
      }
      case 'neighborhood': {
        switch (country) {
          case 'HK':
            return 'city';
          default:
            return 'streets';
        }
      }
      case 'postal_town': {
        return 'city';
      }
      case 'postal_code': {
        return 'zip';
      }
      default: {
        return false;
      }
    }
  };

  removeSimilarity = (components, str) => {
    let stack = '';
    let temp = cloneDeep(components);
    components.every((el, i) => {
      const { long_name } = el;
      stack +=
        stack === ''
          ? helpers.onlyAscii(long_name)
          : ` ${helpers.onlyAscii(long_name)}`;
      const similarity = stringSimilarity.compareTwoStrings(str, stack);
      if (similarity > 0.65) {
        temp = drop(temp, i + 1);
        return false;
      }
      return true;
    });
    return temp;
  };

  handleDetails = (components, init = []) => {
    const country = this.props.country;
    const score = 0.8;

    const temp = {
      streets: init,
      street1: '',
      street2: '',
      street3: ''
    };

    const newComponents = this.removeSimilarity(
      components,
      init[0].value || ''
    );

    newComponents.forEach(component => {
      const { types } = component;
      const { short_name, long_name } = component;

      let type = this.checkMatches(types);
      if (country === 'HK' && type === 'city') {
        const match = find(
          this.props.areas,
          area =>
            stringSimilarity.compareTwoStrings(
              lowerCase(area.slug),
              lowerCase(long_name)
            ) > score
        );
        if (!match) type = 'streets';
      }

      if (['US', 'CA', 'IE'].includes(country) && type === 'state') {
        const match = find(states[country], state => state.code === short_name);
        if (!match) type = 'streets';
      }

      if (type && short_name) {
        switch (type) {
          case 'streets':
          case 'streetNumber':
          case 'route':
            temp.streets.push({
              type: type,
              value: short_name
            });
            break;
          case 'city':
            temp[type] = long_name;
            break;
          default:
            temp[type] = short_name;
        }
      }
    });

    if (country === 'HK' && temp.city) {
      const rs = stringSimilarity.findBestMatch(
        lowerCase(temp.city),
        map(this.props.areas, a => lowerCase(a.slug))
      );

      let match;
      if (rs.ratings[rs.bestMatchIndex].rating > score) {
        if (this.props.areas[rs.bestMatchIndex].parent) {
          match = find(this.props.areas, [
            'id',
            this.props.areas[rs.bestMatchIndex].parent
          ]);
        } else {
          match = this.props.areas[rs.bestMatchIndex];
        }
      }

      if (match) {
        temp.area = match.name.en;
      } else {
        temp.area = temp.city;
      }

      delete temp.city;
    }

    let streets = '';

    // generate full streets
    forEachRight(temp.streets, x => {
      let { value } = x;
      if (x.type === 'streetNumber')
        value = shortForm(helpers.onlyAscii(x.value));

      if (!streets) {
        streets = value;
      } else {
        const separator = x.type === 'streetNumber' ? ' ' : ',';
        streets = `${value}${separator}${streets}`;
      }
    });

    temp.streets = shortForm(streets);

    // format streets into street lines
    let pointer = 'street1';
    const streetElements = split(streets, ',');
    forEach(streetElements, x => {
      if (!temp[pointer]) {
        temp[pointer] = x;
      } else {
        temp[pointer] += `,${x}`;
      }

      if (temp[pointer].length > 20) {
        if (pointer === 'street2') pointer = 'street3';
        if (pointer === 'street1') pointer = 'street2';
      }
    });

    delete temp.streets;

    return temp;
  };

  getFields = {
    base: () => {
      return (
        <>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            <StyledCol>
              <FormTitle>{this.props.t('pickup.form.contact_name')}</FormTitle>
              <StyledFormItem
                validateStatus={this.state['nameStatus'] || ''}
                help={this.props.t(this.state['nameHelp'])}>
                <StyledInput
                  size="large"
                  value={this.state['name']}
                  onChange={e => {
                    this.handleTextInputChange(e.target.value, 'name');
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('name');
                  }}
                />
              </StyledFormItem>
            </StyledCol>
            <StyledCol>
              <FormTitle>
                {this.props.t('pickup.form.company')}
                <span style={formSubtitle}>
                  {this.props.t('common.optional')}
                </span>
              </FormTitle>
              <StyledFormItem
                validateStatus={this.state['companyStatus'] || ''}
                help={this.props.t(this.state['companyHelp'])}>
                <StyledInput
                  size="large"
                  value={this.state['company']}
                  onChange={e => {
                    this.handleTextInputChange(e.target.value, 'company');
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('company');
                  }}
                />
              </StyledFormItem>
            </StyledCol>
          </Row>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            <StyledCol flex={1}>
              <FormTitle>
                {this.props.t('pickup.form.contact_number')}
              </FormTitle>
              <StyledFormItem>
                <StyledSelect
                  size="large"
                  value={this.checkCodeAndCountry(
                    this.state['country'],
                    this.state['phoneCc']
                  )}
                  onChange={val => {
                    const arr = val.split('_');
                    this.handleTextInputChange(arr[0], 'country');
                    this.handleTextInputChange(arr[1], 'phoneCc');
                  }}>
                  {this.phoneCountry.map((x, i) => (
                    <Option
                      key={`${x.key}_${x.value}_${i}`}
                      value={`${x.key}_${x.value}`}
                      title={x.label}>
                      <div>
                        {x.flag}
                        {x.label}
                      </div>
                    </Option>
                  ))}
                </StyledSelect>
              </StyledFormItem>
            </StyledCol>
            <StyledCol flex={2}>
              <FormTitle>&nbsp;</FormTitle>
              <StyledFormItem
                validateStatus={this.state['phoneStatus'] || ''}
                help={this.props.t(this.state['phoneHelp'])}>
                <StyledInput
                  size="large"
                  type="tel"
                  value={this.state['phone']}
                  onChange={e => {
                    const val = e.target.value.replace(/[^0-9]/i, '');
                    this.handleTextInputChange(val, 'phone');
                  }}
                  onBlur={e => {
                    this.handleTextInputBlur('phone');
                  }}
                />
              </StyledFormItem>
            </StyledCol>
          </Row>
        </>
      );
    },
    street1: () => {
      return (
        <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
          <StyledCol>
            <FormTitle className="form-title">
              {this.props.t('pickup.form.address_streets')}
              {this.props.showPostOfficeBoxHint && (
                <div
                  style={{
                    color: '#87898B',
                    fontSize: '14px',
                    lineHeight: '20px',
                    fontWeight: 'normal',
                    fontStyle: 'normal'
                  }}>
                  {this.props.t('pickup.hints.post_office_box_hint')}
                </div>
              )}
              {this.calculateExceed() > 0 && (
                <>
                  {' '}
                  <Popover
                    content={(() => {
                      const { t } = this.props;

                      return (
                        <div style={{ fontSize: '12px' }}>
                          {t('pickup.form.address_tips_1')}
                          <br />
                          {keys(abbreviations).map((key, index) => {
                            const lastIndex = keys(abbreviations).length - 1;
                            return (
                              <span key={key}>
                                <span style={{ fontWeight: 700 }}>{key}</span>
                                {t('pickup.form.address_tips_2')}
                                <span style={{ fontWeight: 700 }}>
                                  {abbreviations[key]}
                                </span>
                                {lastIndex !== index &&
                                  (t('key') === 'en' ? ', ' : '，')}
                                {index % 2 > 0 && <br />}
                              </span>
                            );
                          })}
                        </div>
                      );
                    })()}
                    placement="bottom">
                    <span
                      className="buttonSecond-color"
                      style={{ color: '#57D7DD' }}>
                      <FontAwesomeIcon icon="question-circle" />
                    </span>
                  </Popover>
                </>
              )}
              <div
                style={{
                  float: 'right',
                  fontWeight: 400,
                  fontSize: '11px',
                  color: '#f52229',
                  lineHeight: '18px'
                }}>
                {this.calculateExceed() > 0 &&
                  this.props.t('pickup.err_msg.streets.exceed', {
                    words: this.calculateExceed()
                  })}
              </div>
            </FormTitle>
            <StyledFormItem
              validateStatus={this.state['street1Status'] || ''}
              help={this.props.t(this.state['street1Help'])}>
              <StyledInput
                size="large"
                value={this.state['street1']}
                onChange={e => {
                  this.handleTextInputChange(e.target.value, 'street1');
                }}
                onBlur={this.handleStreetsBlur}
              />
            </StyledFormItem>
          </StyledCol>
        </Row>
      );
    },
    streets: () => {
      return (
        <>
          {this.getFields.street1()}
          <Row type="flex" gutter={14} style={{ paddingTop: '13px' }}>
            <StyledCol>
              <StyledFormItem
                validateStatus={this.state['street2Status'] || ''}
                help={this.props.t(this.state['street2Help'])}>
                <StyledInput
                  size="large"
                  value={this.state['street2']}
                  onChange={e => {
                    this.handleTextInputChange(e.target.value, 'street2');
                  }}
                  onBlur={this.handleStreetsBlur}
                />
              </StyledFormItem>
            </StyledCol>
          </Row>
          <Row type="flex" gutter={14} style={{ paddingTop: '13px' }}>
            <StyledCol>
              <StyledFormItem
                validateStatus={this.state['street3Status'] || ''}
                help={this.props.t(this.state['street3Help'], {
                  maxLength: this.state.maxLength
                })}>
                <StyledInput
                  size="large"
                  value={this.state['street3']}
                  onChange={e => {
                    this.handleTextInputChange(e.target.value, 'street3');
                  }}
                  onBlur={this.handleStreetsBlur}
                />
              </StyledFormItem>
            </StyledCol>
          </Row>
        </>
      );
    },
    zip: () => {
      return (
        <StyledCol>
          <FormTitle>{this.props.t('pickup.form.zip_code')}</FormTitle>
          <StyledFormItem
            validateStatus={this.state['zipStatus'] || ''}
            help={this.props.t(this.state['zipHelp'])}>
            <StyledInput
              size="large"
              value={this.state['zip']}
              placeholder={`${this.props.t(
                'pickup.form.placeholder.for_example'
              )}${get(
                find(this.props.countries, ['alpha-2', this.props.country]),
                'postal-code-sample'
              )}`}
              onChange={e => {
                this.handleTextInputChange(e.target.value, 'zip');
              }}
              onBlur={e => {
                this.handleTextInputBlur('zip');
              }}
            />
          </StyledFormItem>
        </StyledCol>
      );
    },
    area: () => {
      return (
        <StyledCol>
          <FormTitle>{this.props.t('pickup.form.region')}</FormTitle>
          <StyledFormItem
            validateStatus={this.state['areaStatus'] || ''}
            help={this.props.t(this.state['areaHelp'])}>
            <AreaSelect
              t={this.props.t}
              value={
                indexOf(
                  filter(this.props.areas, ['parent', null]).map(
                    x => x.name.en
                  ),
                  this.state['area']
                ) !== -1
                  ? this.state['area']
                  : ''
              }
              onChange={value => {
                this.handleInputChange(value, 'area');
              }}
              onBlur={() => {
                this.handleInputBlur('area');
              }}
            />
          </StyledFormItem>
        </StyledCol>
      );
    },
    unit: () => {
      return (
        <StyledCol>
          <FormTitle>{this.props.t('pickup.form.room_floor_block')}</FormTitle>
          <StyledFormItem
            validateStatus={this.state['unitStatus'] || ''}
            help={this.props.t(this.state['unitHelp'])}>
            <StyledInput
              size="large"
              value={this.state['unit']}
              placeholder={`${this.props.t(
                'pickup.form.placeholder.for_example'
              )}${this.props.t('pickup.form.placeholder.room_floor_block')}`}
              onChange={e => {
                this.handleTextInputChange(e.target.value, 'unit');
              }}
              onBlur={this.handleUnitBlur}
            />
          </StyledFormItem>
        </StyledCol>
      );
    },
    city: () => {
      let formTitle = this.props.t('pickup.form.city');
      if (this.props.country === 'TW')
        formTitle = this.props.t('pickup.form.city_TW');
      if (this.props.country === 'JP')
        formTitle = this.props.t('pickup.form.city_JP');

      // const countries = ['AU', 'NZ', 'KR', 'JP', 'VN'];
      const countries = ['AU', 'NZ', 'KR', 'JP'];
      if (countries.includes(this.props.country)) {
        this.state.cities &&
          this.state.cities.forEach(city => {
            const toComapare = this.state.suggestedCity ?? this.state.city;
            const similarity = stringSimilarity.compareTwoStrings(
              toComapare.toLowerCase(),
              city.toLowerCase()
            );
            if (similarity > 0.65) this.setState({ city });
          });
        return (
          <StyledCol>
            <FormTitle>{formTitle}</FormTitle>
            <StyledFormItem
              validateStatus={this.state['cityStatus'] || ''}
              help={this.props.t(this.state['cityHelp'])}>
              <StyledSelect
                size="large"
                placeholder={
                  this.state.tntSuggesting
                    ? this.props.t('common.loading')
                    : this.props.t('common.select')
                }
                value={this.state.city || undefined}
                onChange={value => {
                  this.handleTextInputChange(value, 'city');
                  this.handleTextInputBlur('city');
                }}
                onBlur={e => {
                  this.handleTextInputBlur('city');
                }}
                disabled={this.state.tntSuggesting && true}>
                {this.state.cities &&
                  this.state.cities.map(r => <Option key={r}>{r}</Option>)}
              </StyledSelect>
            </StyledFormItem>
          </StyledCol>
        );
      }

      return (
        <StyledCol>
          <FormTitle>{formTitle}</FormTitle>
          <StyledFormItem
            validateStatus={this.state['cityStatus'] || ''}
            help={this.props.t(this.state['cityHelp'])}>
            <StyledInput
              size="large"
              value={this.state['city']}
              onChange={e => {
                this.handleTextInputChange(e.target.value, 'city');
              }}
              onBlur={e => {
                this.handleTextInputBlur('city');
              }}
            />
          </StyledFormItem>
        </StyledCol>
      );
    },
    state: () => {
      let formTitle = this.props.t('pickup.form.state');
      if (this.props.country === 'CA')
        formTitle = this.props.t('pickup.form.state_CA');

      return (
        <StyledCol>
          <FormTitle>{formTitle}</FormTitle>
          <StyledFormItem
            validateStatus={this.state['stateStatus'] || ''}
            help={this.props.t(this.state['stateHelp'])}>
            <StateSelect
              t={this.props.t}
              country={this.props.country}
              value={this.state['state']}
              onChange={value => {
                this.handleInputChange(value, 'state');
              }}
              onBlur={() => {
                this.handleInputBlur('state');
              }}
            />
          </StyledFormItem>
        </StyledCol>
      );
    },
    stateInput: () => {
      let formTitle = this.props.t('pickup.form.state');

      return (
        <StyledCol>
          <FormTitle>{formTitle}</FormTitle>
          <StyledFormItem
            validateStatus={this.state['stateStatus'] || ''}
            help={this.props.t(this.state['stateHelp'])}>
            <StyledInput
              size="large"
              value={this.state['state']}
              onChange={e => {
                this.handleTextInputChange(e.target.value, 'state');
              }}
              onBlur={e => {
                this.handleTextInputBlur('state');
              }}
            />
          </StyledFormItem>
        </StyledCol>
      );
    },
    type: () => {
      // var str = this.props.showPickup ? '_pickup' : '_delivery';
      return (
        <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
          <StyledCol>
            <StyledFormItem>
              <StyledRadioGroupHorizontal
                onChange={this.handleTypeOnChange}
                value={this.state.type}>
                <Radio value={'RESIDENTIAL'}>
                  {this.props.t('pickup.form.type_residential')}
                </Radio>
                <Radio value={'BUSINESS'}>
                  {this.props.t('pickup.form.type_business')}
                </Radio>
              </StyledRadioGroupHorizontal>
            </StyledFormItem>
          </StyledCol>
        </Row>
      );
    },
    spacer: () => {
      return <StyledCol></StyledCol>;
    }
  };

  getView = country => {
    if (country === 'HK') {
      return (
        <>
          {this.getFields.base()}
          {this.getFields.type()}
          {this.getFields.streets()}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.unit()}
            {this.getFields.area()}
          </Row>
        </>
      );
    }

    if (['US', 'CA', 'IE'].includes(country)) {
      return (
        <>
          {this.getFields.base()}
          {this.getFields.type()}
          {this.getFields.streets()}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.unit()}
            {this.getFields.zip()}
          </Row>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.city()}
            {this.getFields.state()}
          </Row>
        </>
      );
    }

    // REMARK: APG need state code in AU
    if (country === 'AU' && this.props.carrier === 'apg') {
      return (
        <>
          {this.getFields.base()}
          {this.getFields.type()}
          {this.getFields.streets()}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.unit()}
            {this.getFields.zip()}
          </Row>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.city()}
            {this.getFields.stateInput()}
          </Row>
        </>
      );
    }

    if (country === 'JP') {
      return (
        <>
          {this.getFields.base()}
          {this.getFields.type()}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {/* {this.getFields.zipAutocomplete()} */}
            {this.getFields.zip()}
          </Row>
          {this.getFields.streets()}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.unit()}
            {this.getFields.city()}
          </Row>
        </>
      );
    }

    if (
      get(
        find(this.props.countries, ['alpha-2', this.props.country]),
        'require-postal-code'
      )
    ) {
      return (
        <>
          {this.getFields.base()}
          {this.getFields.type()}
          {this.getFields.streets()}
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.unit()}
            {this.getFields.zip()}
          </Row>
          <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
            {this.getFields.city()}
            {this.getFields.spacer()}
          </Row>
        </>
      );
    }

    return (
      <>
        {this.getFields.base()}
        {this.getFields.type()}
        {this.getFields.streets()}
        <Row type="flex" gutter={14} style={{ paddingTop: '20px' }}>
          {this.getFields.unit()}
          {this.getFields.city()}
        </Row>
      </>
    );
  };

  getSuggestion(params) {
    let { country, zip } = params;

    let fetchSuggestion = async () => {
      var options = {
        method: 'POST',
        uri: process.env.REACT_APP_BASE_URL + '/shipments/zip-code-suggestion',
        body: {
          country,
          zip
        },
        json: true
      };

      let tnt = this.props.carrier === 'tnt' ? 'tnt' : 'not_tnt';

      try {
        const data = await rp(options);
        if (data.success && data.data.cities) {
          this.setState({ cities: data.data.cities });
          return;
        } else {
          helpers.message.error(
            this.props.t(`pickup.err_msg.zip.format.${tnt}`),
            'address',
            5
          );
          this.setState({
            cities: null,
            zipStatus: 'error',
            cityStatus: 'error'
          });
        }
      } catch (e) {
        helpers.message.error(
          this.props.t(`pickup.err_msg.zip.format.${tnt}`),
          'address',
          5
        );
        this.setState({
          cities: null,
          zipStatus: 'error',
          cityStatus: 'error'
        });
      }
    };

    fetchSuggestion = fetchSuggestion.bind(this);

    fetchSuggestion();
  }

  handleAutocompleteRemove = name => {
    this.setState(
      {
        [name]: ''
      },
      this.autoSave
    );
  };

  handleAutocompleteError = (status, clearSuggestions) => {
    console.log('Error from Google Maps API', status);
    clearSuggestions();
  };

  handleDrawerOpen = name => {
    this.setState(
      {
        drawerName: name,
        drawerVisible: true
      },
      () => {
        // allow scrolling for desktop not display drawer
        setTimeout(() => {
          document.querySelector('body').style.overflow = '';
          document.querySelector('body').style.touchAction = '';
        }, 0);
      }
    );
  };

  handleDrawerClose = () => {
    this.setState({
      drawerVisible: false
    });
  };

  handleDrawerComplete = () => {
    this.setState({
      drawerVisible: false
    });
  };

  handleGtmFire = (name, isAutocomplete) => {
    const fields = [
      'street1',
      'street2',
      'street3',
      'area',
      'zip',
      'city',
      'state'
    ];

    const getAddressData = () => {
      var obj = {};
      fields.forEach(field => {
        obj[field] = this.state[field];
      });
      return obj;
    };

    if (isAutocomplete) {
      window.dataLayer.push({
        event: 'Select Autocomplete Address',
        addressData: JSON.stringify(getAddressData()),
        ecommerce: undefined
      });
    } else if (
      fields.indexOf(name) !== -1 &&
      this.state.isSuggested &&
      this.state[name] !== this.state['gtm' + name]
    ) {
      var newState = {};
      newState['gtm' + name] = this.state[name];
      this.setState(newState);

      window.dataLayer.push({
        event: 'Update Autocomplete Address',
        addressData: JSON.stringify(getAddressData()),
        ecommerce: undefined
      });
    }
  };

  focusInput = React.createRef();

  render() {
    return <>{this.getView(this.props.country)}</>;
  }
}

const mapStateToProps = state => {
  return {
    loading: !!state.shipments.loading,
    shipmentSuccess: !!state.shipments.shipmentSuccess,
    shipmentData: state.shipments.shipmentData || {},
    pickupData: state.shipments.pickupData || {},
    user: state.auth.user || false,
    uiLoading: !!(state.users.loading || !state.shipments.getAutoSaveFinished),
    addresses: state.users.addresses || false,
    recoverFormData: state.shipments.recoverFormData || {},
    countries: state.shipments.countries || [],
    areas: state.shipments.areas
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
  AddressCard
);
